<template>
  <div>
    <v-layout text-xs-center wrap>
      <v-flex>
        <Title title="Mes plateformes"></Title>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 offset-sm1 sm10 offset-md1 md10 lg8 offset-lg2 xl6 offset-xl3>
        <v-text-field v-model="filter" label="Filtre" placeholder="3DS, PCB, PS1, ..."></v-text-field>
        <PlatformsOrganisms :platforms="platforms" @go-to-platform="$emit('go-to-platform', $event)"/>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import PlatformsOrganisms from '@/components/organisms/Platforms.vue';
  import Title from '@/components/atoms/Title';

  export default {
    components: { PlatformsOrganisms, Title },
    props: ['myPlatforms'],
    data() {
      return {
        filter: '',
      };
    },
    computed: {
      platforms: {
        get() {
          const platforms = this.myPlatforms;
          const searchString = this.filter.toLocaleLowerCase().trim();
          if (!searchString) {
            return platforms;
          }
          return platforms.filter(platform => platform.toLowerCase().indexOf(searchString) >= 0);
        },
      },
    },
  };
</script>
